import React from 'react';
import Error404 from './../../templates/Error404.jsx'
import ErrorSystemImage from './../../images/errors 404/error-system.svg'

const ErrorSystem = () => (
    < Error404
        ImageError={ErrorSystemImage}
        Title=""
        Description="Ups, disculpa por ilusionarte pero no como ella lo hizo contigo... pero es que estamos trabajando en esta pagina, porque no te tomas un cafe como nosotros lo estamos haciendo..."
        LinkRedireccion="/"
        TextRedireccion="Inicio"
    />
)

export default ErrorSystem;